<div
  ktOffcanvas
  [options]="offcanvasOptions"
  id="kt_twixor_offcanvas"
  class="offcanvas offcanvas-right p-5"
>
  <div class="close">
    <a id="kt_twixor_close" class="btn btn-xs btn-icon btn-success">
      <i class="ki ki-close icon-xs"></i>
    </a>
  </div>
  <div class="offcanvas-content h-100">
    <iframe [src]="url" class="border-0 h-100 w-100"></iframe>
  </div>
</div>
